import Vue from 'vue'
// import qiniuCropUpload from './sub/qiniuCropUpload'
import yznconfirm from './sub/yznconfirm'
// import yznUtil from "../assets/js/qnUpload";

// const PopupBox = Vue.extend(qiniuCropUpload);
// qiniuCropUpload.install = function (cut) {
//   let qnupload = new PopupBox().$mount()
//   document.body.appendChild(qnupload.$el)
//   // dom更新后回调
//   Vue.nextTick(() => {
//     qnupload.show = true;
//   })
// }

// confirm弹框
const yznConfirm = Vue.extend(yznconfirm);
let confirm = function(options) {
    return new Promise((res, rej) => {
        let confirmDom = new yznConfirm({
            el: document.createElement('div')
        })
        document.body.appendChild(confirmDom.$el);

        confirmDom.options = options;
        confirmDom.ok = function() {
            if (confirmDom.options.input) {
                if (confirmDom.options.input.value) {
                    res(confirmDom.options.input.value)
                    confirmDom.isShow = false
                } else {
                    this.$Message.warning("请输入内容");
                }
            } else {
                res()
                confirmDom.isShow = false
            }
        }
        confirmDom.close = function() {
            rej()
            confirmDom.isShow = false
        }

    })
}

export default { confirm }


// WEBPACK FOOTER //
// ./src/components/popup.js